import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "kindergarten-detail-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "info-section" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "lms-systems-section" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = { class: "mb-3" }
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = { class: "mb-3" }
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = { class: "mb-3" }
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "mb-3" }
const _hoisted_23 = ["value"]
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "mb-3" }
const _hoisted_27 = { class: "mb-3" }
const _hoisted_28 = {
  type: "submit",
  class: "btn btn-primary"
}
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "mb-3" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "mb-3" }
const _hoisted_34 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_modal = _resolveComponent("b-modal")!
  const _component_b_th = _resolveComponent("b-th")!
  const _component_b_tr = _resolveComponent("b-tr")!
  const _component_b_thead = _resolveComponent("b-thead")!
  const _component_b_td = _resolveComponent("b-td")!
  const _component_b_tbody = _resolveComponent("b-tbody")!
  const _component_b_table_simple = _resolveComponent("b-table-simple")!
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[73] || (_cache[73] = _createElementVNode("h3", null, "Детали ДО", -1)),
    (_ctx.kindergartenDocumentInfo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[32] || (_cache[32] = _createElementVNode("h4", null, "Информация о ДО", -1)),
            _createElementVNode("p", null, [
              _cache[28] || (_cache[28] = _createElementVNode("strong", null, "ID:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.kindergartenDocumentInfo.id), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[29] || (_cache[29] = _createElementVNode("strong", null, "БИН:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.kindergartenDocumentInfo.bin), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[30] || (_cache[30] = _createElementVNode("strong", null, "КБЕ:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.kindergartenDocumentInfo.kbe), 1)
            ]),
            _createElementVNode("p", null, [
              _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Тип собственности:", -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.kindergartenDocumentInfo.ownershipType.name) + " (" + _toDisplayString(_ctx.kindergartenDocumentInfo.ownershipType.code) + ")", 1)
            ])
          ]),
          (_ctx.hasAccess(_ctx.adminRoles))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-warning",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openEditKindergartenModal && _ctx.openEditKindergartenModal(...args)))
              }, "Внести изменение в ДО"))
            : _createCommentVNode("", true),
          _createVNode(_component_b_modal, {
            modelValue: _ctx.showEditKindergartenModal,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showEditKindergartenModal) = $event)),
            title: "Редактирование ДО",
            "hide-footer": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitUpdatedForm && _ctx.submitUpdatedForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _cache[33] || (_cache[33] = _createElementVNode("label", {
                    for: "bin",
                    class: "form-label"
                  }, "БИН", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.updatedDocument.bin) = $event)),
                    class: "form-control",
                    id: "bin",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.updatedDocument.bin]
                  ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _cache[34] || (_cache[34] = _createElementVNode("label", {
                    for: "kbe",
                    class: "form-label"
                  }, "КБЕ", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.updatedDocument.kbe) = $event)),
                    class: "form-control",
                    id: "kbe",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.updatedDocument.kbe]
                  ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                  _cache[35] || (_cache[35] = _createElementVNode("label", {
                    for: "ownershipType",
                    class: "form-label"
                  }, "Тип собственности", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.updatedDocument.ownershipType) = $event)),
                    class: "form-select",
                    id: "ownershipType",
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ownershipTypes, (ownership) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: ownership.code,
                        value: ownership
                      }, _toDisplayString(ownership.name), 9, _hoisted_7))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.updatedDocument.ownershipType]
                  ])
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary"
                }, "Сохранить изменения", -1))
              ], 32)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_8, [
            _cache[52] || (_cache[52] = _createElementVNode("h4", null, "Системы LMS", -1)),
            (_ctx.hasAccess(_ctx.adminRoles))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-success",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.openCreateLmsModal && _ctx.openCreateLmsModal(...args)))
                }, "Добавить ЛМС"))
              : _createCommentVNode("", true),
            _createVNode(_component_b_table_simple, { bordered: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_b_thead, { "head-variant": "light" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_b_tr, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[37] || (_cache[37] = [
                            _createTextVNode("ID LMS")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[38] || (_cache[38] = [
                            _createTextVNode("Название ДО")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[39] || (_cache[39] = [
                            _createTextVNode("Банк БИН")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[40] || (_cache[40] = [
                            _createTextVNode("Банк БИК")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[41] || (_cache[41] = [
                            _createTextVNode("ИИК")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                            _createTextVNode("Группа региона")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[43] || (_cache[43] = [
                            _createTextVNode("Тип региона")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[44] || (_cache[44] = [
                            _createTextVNode("Тип населенного пункта")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[45] || (_cache[45] = [
                            _createTextVNode("Населенный пункт")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[46] || (_cache[46] = [
                            _createTextVNode("Адрес")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[47] || (_cache[47] = [
                            _createTextVNode("Номер договора и дата")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[48] || (_cache[48] = [
                            _createTextVNode("Проектная мощность")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[49] || (_cache[49] = [
                            _createTextVNode("Сумма надбавки")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_b_th, null, {
                          default: _withCtx(() => _cache[50] || (_cache[50] = [
                            _createTextVNode("Статус ДО")
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_b_tbody, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.kindergartenDocumentInfo.lmsSystems, (lmsSystem, index) => {
                      return (_openBlock(), _createBlock(_component_b_tr, { key: index }, {
                        default: _withCtx(() => [
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.lmsId) + " ", 1),
                              (_ctx.hasAccess([..._ctx.adminRoles, ..._ctx.accountantRoles]))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-sm",
                                    onClick: ($event: any) => (_ctx.openEditLmsModal(lmsSystem))
                                  }, " ✏️ ", 8, _hoisted_9))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.kindergartenName), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.bankBin), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.bankBic), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.iik), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.regionGroup?.code), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.regionType?.code) + ": " + _toDisplayString(lmsSystem.regionType?.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.localityType?.code) + ": " + _toDisplayString(lmsSystem.localityType?.name), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.kato?.nameRu), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.address), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.contractNumberAndDate), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(lmsSystem.childrenCapacity), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lmsSystem.kindergartenAllowances, (allowance, allowanceIndex) => {
                                return (_openBlock(), _createElementBlock("p", { key: allowanceIndex }, " (" + _toDisplayString(allowance.educationalType?.code) + ") " + _toDisplayString(allowance.educationalType?.name) + " : " + _toDisplayString(allowance.allowanceAmount) + " тг. ", 1))
                              }), 128)),
                              (_ctx.hasAccess(_ctx.adminRoles))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-sm",
                                    onClick: ($event: any) => (_ctx.openCreateAllowanceModal(lmsSystem))
                                  }, _cache[51] || (_cache[51] = [
                                    _createElementVNode("b", null, "+", -1)
                                  ]), 8, _hoisted_10))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_b_td, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.getStatusLabel(lmsSystem.status)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_b_modal, {
            modelValue: _ctx.showLmsModal,
            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.showLmsModal) = $event)),
            title: "Управление ЛМС",
            "hide-footer": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                onSubmit: _cache[21] || (_cache[21] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCreateLmsForm && _ctx.submitCreateLmsForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[53] || (_cache[53] = _createElementVNode("label", {
                    for: "kindergarten_name",
                    class: "form-label"
                  }, "Название ДО", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.currentLmsSystem.kindergartenName) = $event)),
                    class: "form-control",
                    id: "kindergarten_name",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.currentLmsSystem.kindergartenName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _cache[54] || (_cache[54] = _createElementVNode("label", {
                    for: "bankBic",
                    class: "form-label"
                  }, "БИК банка", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.currentLmsSystem.bankBic) = $event)),
                    class: "form-control",
                    id: "bankBic",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.currentLmsSystem.bankBic]
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _cache[55] || (_cache[55] = _createElementVNode("label", {
                    for: "bankBin",
                    class: "form-label"
                  }, "БИН банка", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.currentLmsSystem.bankBin) = $event)),
                    class: "form-control",
                    id: "bankBin",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.currentLmsSystem.bankBin]
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _cache[56] || (_cache[56] = _createElementVNode("label", {
                    for: "iik",
                    class: "form-label"
                  }, "ИИК", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.currentLmsSystem.iik) = $event)),
                    class: "form-control",
                    id: "iik",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.currentLmsSystem.iik]
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _cache[57] || (_cache[57] = _createElementVNode("label", {
                    for: "lmsId",
                    class: "form-label"
                  }, "ID ЛМС", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.currentLmsSystem.lmsId) = $event)),
                    class: "form-control",
                    id: "lmsId",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.currentLmsSystem.lmsId]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[58] || (_cache[58] = _createElementVNode("label", {
                    for: "lmsName",
                    class: "form-label"
                  }, "НАЗВАНИЕ ЛМС", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentLmsSystem.lmsName) = $event)),
                    class: "form-control",
                    id: "lmsName"
                  }, null, 512), [
                    [_vModelText, _ctx.currentLmsSystem.lmsName]
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _cache[59] || (_cache[59] = _createElementVNode("label", {
                    for: "katoGroup",
                    class: "form-label"
                  }, "Като", -1)),
                  _createVNode(_component_multiselect, {
                    modelValue: _ctx.currentLmsSystem.kato,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.currentLmsSystem.kato) = $event)),
                    options: _ctx.katoList,
                    searchable: true,
                    closeOnSelect: true,
                    "track-by": "code",
                    "custom-label": _ctx.formattedKatoLabel,
                    placeholder: "Выберите Като",
                    multiple: false,
                    "clear-on-select": true
                  }, null, 8, ["modelValue", "options", "custom-label"])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _cache[60] || (_cache[60] = _createElementVNode("label", {
                    for: "address",
                    class: "form-label"
                  }, "Адрес", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.currentLmsSystem.address) = $event)),
                    class: "form-control",
                    id: "address",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.currentLmsSystem.address]
                  ])
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _cache[61] || (_cache[61] = _createElementVNode("label", {
                    for: "contractNumberAndDate",
                    class: "form-label"
                  }, "Номер договора и дата", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.currentLmsSystem.contractNumberAndDate) = $event)),
                    class: "form-control",
                    id: "contractNumberAndDate",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.currentLmsSystem.contractNumberAndDate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _cache[62] || (_cache[62] = _createElementVNode("label", {
                    for: "regionGroup",
                    class: "form-label"
                  }, "Группа региона", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.currentLmsSystem.regionGroup) = $event)),
                    class: "form-select",
                    id: "regionGroup",
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionGroups, (regionGroup) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: regionGroup.code,
                        value: regionGroup
                      }, _toDisplayString(regionGroup.code), 9, _hoisted_21))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.currentLmsSystem.regionGroup]
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _cache[63] || (_cache[63] = _createElementVNode("label", {
                    for: "localityType",
                    class: "form-label"
                  }, "Тип населенного пункта", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.currentLmsSystem.localityType) = $event)),
                    class: "form-select",
                    id: "localityType",
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localityTypes, (localityType) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: localityType.code,
                        value: localityType
                      }, _toDisplayString(localityType.name), 9, _hoisted_23))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.currentLmsSystem.localityType]
                  ])
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _cache[64] || (_cache[64] = _createElementVNode("label", {
                    for: "regionType",
                    class: "form-label"
                  }, "Тип региона", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.currentLmsSystem.regionType) = $event)),
                    class: "form-select",
                    id: "regionType",
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionTypes, (regionType) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: regionType.code,
                        value: regionType
                      }, _toDisplayString(regionType.name), 9, _hoisted_25))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.currentLmsSystem.regionType]
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _cache[65] || (_cache[65] = _createElementVNode("label", {
                    for: "childrenCapacity",
                    class: "form-label"
                  }, "Проектная мощность", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.currentLmsSystem.childrenCapacity) = $event)),
                    class: "form-control",
                    id: "childrenCapacity"
                  }, null, 512), [
                    [_vModelText, _ctx.currentLmsSystem.childrenCapacity]
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _cache[67] || (_cache[67] = _createElementVNode("label", {
                    for: "status",
                    class: "form-label"
                  }, "Статус ДО", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.currentLmsSystem.status) = $event)),
                    class: "form-select",
                    id: "status",
                    required: ""
                  }, _cache[66] || (_cache[66] = [
                    _createElementVNode("option", { value: "ACTIVE" }, "Активный", -1),
                    _createElementVNode("option", { value: "INACTIVE" }, "Не активный", -1)
                  ]), 512), [
                    [_vModelSelect, _ctx.currentLmsSystem.status]
                  ])
                ]),
                _createElementVNode("button", _hoisted_28, _toDisplayString(_ctx.isEditMode ? "Сохранить изменения" : "Создать ЛМС"), 1)
              ], 32)
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_b_modal, {
            modelValue: _ctx.showCreateAllowanceModal,
            "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.showCreateAllowanceModal) = $event)),
            title: "Добавить Надбавку",
            "hide-footer": ""
          }, {
            default: _withCtx(() => [
              _createElementVNode("form", {
                onSubmit: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitCreateAllowanceForm && _ctx.submitCreateAllowanceForm(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _cache[68] || (_cache[68] = _createElementVNode("label", {
                    for: "educationalType",
                    class: "form-label"
                  }, "Тип образования", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.newAllowance.educationalType) = $event)),
                    class: "form-select",
                    id: "educationalType",
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.educationalTypes, (type) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: type.code,
                        value: type
                      }, _toDisplayString(type.name), 9, _hoisted_30))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.newAllowance.educationalType]
                  ])
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _cache[69] || (_cache[69] = _createElementVNode("label", {
                    for: "durationTime",
                    class: "form-label"
                  }, "Время прибывание", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.newAllowance.durationTime) = $event)),
                    class: "form-select",
                    id: "durationTime",
                    required: ""
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.durationTimeList, (type) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: type.code,
                        value: type
                      }, _toDisplayString(type.name), 9, _hoisted_32))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.newAllowance.durationTime]
                  ])
                ]),
                _createElementVNode("div", _hoisted_33, [
                  _cache[70] || (_cache[70] = _createElementVNode("label", {
                    for: "allowanceAmount",
                    class: "form-label"
                  }, "Сумма надбавки", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.newAllowance.allowanceAmount) = $event)),
                    class: "form-control",
                    id: "allowanceAmount",
                    step: "0.01",
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.newAllowance.allowanceAmount]
                  ])
                ]),
                _cache[71] || (_cache[71] = _createElementVNode("button", {
                  type: "submit",
                  class: "btn btn-primary"
                }, "Создать", -1))
              ], 32)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_34, _cache[72] || (_cache[72] = [
          _createElementVNode("p", null, "Загрузка информации...", -1)
        ])))
  ]))
}